import { render, staticRenderFns } from "./UserActivityView.vue?vue&type=template&id=05a6d932&scoped=true&"
import script from "./UserActivityView.vue?vue&type=script&lang=js&"
export * from "./UserActivityView.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityView.vue?vue&type=style&index=0&id=05a6d932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6d932",
  null
  
)

export default component.exports